/* Breakpoints in Figma
compact 0 - 599 (xs 0 - 599)
medium 600 - 839 (sm 600 - 899)
expanded 840 - 1199 (md 900 - 1199)
large 1200 - 1599 (lg 1200 - 1535)
extralarge 1600 + (xl 1535 +)
*/
export const breakpoints = {
    values: {
        compact: 0,
        medium: 800,
        expanded: 1025,
        large: 1360,
        extralarge: 1600,
    },
};
export default breakpoints;
